import { button, buttonAccent } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import React from 'react';

type IService52WeeksRulesProps = {
    label: string;
    onClick(): void;
} & WithStyles<typeof styles>;

const Service52WeeksRules: React.FC<IService52WeeksRulesProps> = ({ classes, label, onClick }) => (
    <>
        <h2 className={classes.title}>Зачем нужен сервис 52 недели богатства?</h2>
        <div className={classes.pictureBlock}>
            <p className={classes.text}>
                Сервис 52 недели богатства помогает легко войти в тему накоплений.
                <br /> Начинай откладывать минимальную сумму, чтобы привыкнуть и втянуться. Постепенно, неделя за
                неделей, эта сумма будет расти. В конце года у тебя на счете образуется капитал, который ты накопишь
                незаметно для себя.
            </p>
            <img src={require('./images/why.png')} alt="why" />
        </div>
        <h2 className={classes.title}>Куда откладывать накопленные деньги?</h2>
        <div className={classes.pictureBlock}>
            <p className={classes.text}>
                Вариант 1. Завести отдельный счет или виртуальную карту в интернет-банке. Любой банк дает это сделать
                бесплатно.
                <br /> Вариант 2. Инвестировать накопленные деньги на фондовом рынке. Так они будут приносить доход уже
                с первой недели. Инвестировать можно начать сразу или сделать это своим следующим шагом.
            </p>
            <img src={require('./images/where.png')} alt="where" />
        </div>
        <h2 className={classes.title}>Правила</h2>
        <ol className={classes.text}>
            <li>
                Определись, с какой суммы хочешь начать копить. Учти, что эта сумма будет увеличиваться еще на столько
                же каждую следующую неделю. Например, если ты решил начать со 100 рублей, то на второй неделе тебе нужно
                отложить 200, на третьей 300 и т.д.
            </li>
            <li>
                Сервис покажет таблицу с расчетом. Твоя задача откладывать с заданной периодичностью определенную сумму
                и отмечать этот факт в таблице.
            </li>
            <li>В каждый момент времени сервис покажет, следуешь ты намеченному плану или нет.</li>
            <li>Сумму и дату начала нельзя менять после начала расчета.</li>
            <li>Отсчет промежутка времени для инвестиции начинается с дня, который указан в параметрах.</li>
            <li>Все данные и параметры можно сбросить, но тогда все внесенные данные будут утеряны.</li>
        </ol>
        <button className={classes.button} onClick={onClick}>
            {label}
        </button>
    </>
);

const styles = (theme: ITheme) =>
    createStyles({
        title: {
            fontSize: 22,
            textAlign: 'center',
        },
        text: {
            fontSize: 16,
        },
        pictureBlock: {
            display: 'flex',

            '& > img': {
                marginLeft: 100,

                [theme.breakpoints.down('xs')]: {
                    marginLeft: 0,
                    width: 100 + '%',
                },
            },

            [theme.breakpoints.down('xs')]: {
                flexDirection: 'column',
            },
        },
        button: {
            ...button(theme),
            ...buttonAccent(theme),
            margin: '3rem auto',
            display: 'block',
            width: 200,
        },
    });

export default injectSheet(styles)(Service52WeeksRules);
